import { MarketState } from '../types'
import { getLCContract } from '../../utils/contractHelpers'
import { getBigNumberFromEthers } from '../../utils/formatBalance'

export const getMarketData = async (): Promise<MarketState> => {
  const LCContract = getLCContract()
  const totalSupply = await LCContract.totalSupply()
  return { lcSupply: getBigNumberFromEthers(totalSupply).toString(), tvl: null }
}
